import { QueryResult, useQuery } from '@apollo/client'
import { Country, PyramidPastValuesQuery, PyramidType, QueryPyramidPastValuesArgs } from '../../../types'
import { PAST_PYRAMID_VALUES } from '../Queries'

export default (
  companyId: string,
  country: Country,
  pyramidType: PyramidType,
  year: number,
  month: number,
): QueryResult<PyramidPastValuesQuery, QueryPyramidPastValuesArgs> => {
  const variables = {
    companyId,
    country,
    pyramidType,
    year,
    month,
  }

  return useQuery<PyramidPastValuesQuery, QueryPyramidPastValuesArgs>(PAST_PYRAMID_VALUES, {
    variables: variables,
    fetchPolicy: 'network-only',
  })
}
